(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-kk-newsletter-feedback]').forEach((section) => {
      if (section.dataset.feedbackReady) return;
      section.dataset.feedbackReady = 'true';
      const form = section.querySelector('form');
      const result = section.querySelector('[data-kk-newsletter-result]');
      const dialog = section.querySelector('dialog');
      const key = `kk:newsletter:${form.id}`;
      const readPending = () => {
        try {
          const item = JSON.parse(sessionStorage.getItem(key));
          return item?.path === location.pathname && Date.now() - item.time < 900000 ? item : null;
        } catch { return null; }
      };
      // Keep Shopify's native submission, consent checks and CAPTCHA intact.
      form.addEventListener('submit', () => {
        if (!form.checkValidity()) return;
        try { sessionStorage.setItem(key, JSON.stringify({path: location.pathname, scroll: window.scrollY, time: Date.now()})); } catch {}
      });
      if (!result || !dialog || typeof dialog.showModal !== 'function') return;
      const pending = readPending();
      const heading = dialog.querySelector('[data-feedback-heading]');
      heading.textContent = result.dataset.state === 'success' ? section.dataset.successHeading : section.dataset.errorHeading;
      dialog.querySelector('[data-feedback-message]').replaceChildren(...[...result.childNodes].map(node => node.cloneNode(true)));
      result.hidden = true;
      const url = new URL(location.href);
      if (url.hash === `#${form.id}` || url.hash === '#contact_form') url.hash = '';
      url.searchParams.delete('customer_posted');
      history.replaceState(history.state, '', url);
      const close = () => dialog.close();
      dialog.querySelectorAll('[data-feedback-close]').forEach(button => button.addEventListener('click', close));
      dialog.addEventListener('click', event => {
        const box = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) close();
      });
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('kk-newsletter-modal-open');
        form.querySelector(result.dataset.state === 'success' ? 'button[type="submit"]' : 'input[type="email"]')?.focus({preventScroll:true});
      });
      if (pending) window.scrollTo({top:pending.scroll,behavior:'instant'});
      dialog.showModal();
      document.documentElement.classList.add('kk-newsletter-modal-open');
      dialog.querySelector('[data-feedback-close]')?.focus({preventScroll:true});
      try { sessionStorage.removeItem(key); } catch {}
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
